/**
 * Tiny XSS-safe HTML utilities.
 *
 * We use these where we render server data via dangerouslySetInnerHTML to
 * stop attackers from injecting <script> or event handlers through
 * AI-generated / user-uploaded text fields.
 */

// Escape HTML special characters so the resulting string is safe to
// concatenate into HTML. Keep it ASCII-fast — no DOM allocation.
export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Render a plain-text message containing **bold** and \n markers as
 * safe HTML. Used for chat bubbles. Escapes everything else.
 */
export function renderChatMarkdownSafe(text) {
  return escapeHtml(text)
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br/>');
}
